import React, {ReactElement} from 'react';
import {bindActionCreators, Dispatch} from 'redux';
import {connect} from 'react-redux';
import {Text, Bold} from '@vizir-banking/banking-app-core/dist/layout';
import {SchemaNames} from '@vizir-banking/banking-app-core/dist/common/single-input-form/types';
import {addCreationUser} from '@vizir-banking/banking-app-core/dist/redux/onboarding/add-creation-user';
import {User} from '@vizir-banking/banking-app-core/dist/redux/user/types';

import {ONBOARDING_SCREENS} from '~/navigation/screen-definitions';
import translate from '~/i18n/translate';
import {
  OnboardingNavigationProps,
  withOnboardingNavigation,
} from '~/onboarding/navigation/with-onboarding-navigation';
import SingleInputForm from '~/onboarding/components/single-input-form/single-input-form';
import {OnboardingScreen} from '~/onboarding/components/screen-with-onboarding-progress/screen-with-onboarding-progress';

import {Checkbox} from './email.styles';

const actionCreators = {addCreationUser};

type Props = ReturnType<typeof mapDispatchToProps> & OnboardingNavigationProps;

class EmailScreen extends React.PureComponent<Props> {
  state = {
    checked: true,
  };

  submit = (value: string): void => {
    const {checked} = this.state;
    const {navigateToNextOnboardingScreen, actions} = this.props;

    actions.addCreationUser('email', value);
    actions.addCreationUser('newsletterAccept', checked);

    navigateToNextOnboardingScreen();
  };

  renderText(): ReactElement {
    return (
      <>
        <Text>
          {translate('onboarding.WhatsYour')}
          <Bold>{translate('onboarding.email')}</Bold>?
        </Text>
      </>
    );
  }

  onChangeValue = (checked: boolean): void => {
    this.setState({checked});
  };

  render(): ReactElement {
    const {checked} = this.state;
    return (
      <OnboardingScreen showProgress>
        <SingleInputForm
          reduxValueKey="email"
          validationSchemaName={SchemaNames.EMAIL}
          content={this.renderText}
          onSubmit={this.submit}
          maxLength={255}
          autoCapitalize="none"
        >
          <Checkbox
            checked={checked}
            text={translate('onboarding.ReceiveEmailText')}
            onChangeValue={this.onChangeValue}
          />
        </SingleInputForm>
      </OnboardingScreen>
    );
  }
}

type Actions = {
  addCreationUser: (fieldName: keyof User, value: string | boolean) => void;
};

const mapDispatchToProps = (dispatch: Dispatch): {actions: Actions} => ({
  actions: bindActionCreators(actionCreators, dispatch),
});

export default connect(
  null,
  mapDispatchToProps,
)(withOnboardingNavigation(EmailScreen, ONBOARDING_SCREENS.email));
